import { ICommand } from 'core-ts-types';
import { IAPAlternatePlanListQueryListItem } from '../../../alternate_plans/queries/ap_alternate_plan_list_query';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';

class AlternatePlansListItem {
  private item: IAPAlternatePlanListQueryListItem;
  constructor(
    private $state: ng.ui.IStateService,
    private ngAPUserModeConfig: APUserModeConfig,
    private loadAlternatePlanDetailsCommand: ICommand
  ) {}

  loadToPlan() {
    return this.loadAlternatePlanDetailsCommand(this.item.id, 'to');
  }
}
angular.module('capability-ng-academic-planner').component('alternatePlanListItem', {
  templateUrl:
    'capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_list_item/alternate_plan_list_item.html',
  controller: AlternatePlansListItem,
  bindings: {
    item: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_list_item/alternate_plan_list_item.ts